import { initializeApp } from "firebase/app";
import {
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyChGiiKdW2YU2bcyT26MhmdEvC6vOXUvPU",
  authDomain: "tutorbridge-8b0a7.firebaseapp.com",
  projectId: "tutorbridge-8b0a7",
  storageBucket: "tutorbridge-8b0a7.firebasestorage.app",
  messagingSenderId: "19622660376",
  appId: "1:19622660376:web:9657cdd02fcff666f0f66d",
  measurementId: "G-BGGJLENPL8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// ✅ Export necessary modules
export {
  auth,
  signOut, // ✅ Add this to your exports
  googleProvider,
  createUserWithEmailAndPassword,
  signInWithPopup,
};
